// @flow
import React from 'react'
import Modal from 'react-modal'
import styled from 'styled-components'

const modalStyle = {
  content: {
    width: '90%'
  }
}

const Iframe = styled.iframe`
  display: block;
  width: 100%;
  height: 70vh;
`

type Props = {
  options: Object,
  isOpen: boolean,
  onRequestClose: Function
}

const TourModal = ({ isOpen, onRequestClose, options: { src } }: Props) => {
  if (!isOpen) return null

  return (
    <Modal
      isOpen={isOpen}
      className="modal"
      style={modalStyle}
      contentLabel="Matterport Tour"
      overlayClassName="modal-overlay"
      onRequestClose={onRequestClose}
    >
      <div className="modal-header">
        <h5 style={{ marginBottom: 0 }}>Virtual Tour</h5>
        <button type="button" className="modal-close" onClick={onRequestClose}>
          &times;
        </button>
      </div>
      <Iframe src={src} frameBorder="0" allowFullScreen />
      <div className="modal-footer">
        <a
          href={src}
          target="_blank"
          rel="noopener noreferrer"
          style={{ fontSize: '14px' }}
        >
          Open in new tab <span className="fa fa-external-link" />
        </a>
      </div>
    </Modal>
  )
}

TourModal.defaultProps = {
  options: {
    src: ''
  }
}

export default TourModal



// WEBPACK FOOTER //
// ./src/components/VirtualTours/components/TourModal/index.js